// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"805":"25f4ac2a","817":"f518e38b"}[chunkId] || chunkId) + "." + {"448":"b4026a3dabafe400","629":"7a80479af66bf0d7","644":"a68d80de38e6d272","768":"0bb9187f1f5a2310","805":"0de419754430e75e","816":"d2fccf5f5ecbfffe","817":"ddc3ec96230226a6"}[chunkId] + ".js";
};